import styled from 'styled-components';
import { getThemeColor, getThemeTypography } from 'utils/styled';

export const Root = styled.label`
  ${getThemeTypography('label')};
  color: ${getThemeColor('d1')};
  display: inline-block;
  margin-bottom: 5px;
`;
